<script setup>
import { getCurrentInstance, reactive } from 'vue'

const props = defineProps({
    options: { type: Object, required: true }
})

// Define emits explicitly
const emit = defineEmits(['hide-modal'])

// Access store via proxy
const { proxy } = getCurrentInstance()
const store = proxy.$store

// Use reactive to wrap the row object to ensure template binding is robust
const row = reactive({ ...props.options.row })

const saveNotes = () => {
    store.dispatch('itemData/update', {
        tableName: 'courses_bookings',
        id: row.id,
        data: { notes: row.notes }
    })
}
</script>

<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Notes</h4>
                <button type="button" class="btn-close" @click="emit('hide-modal')" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <textarea v-model="row.notes" placeholder="Type here…" rows="10"
                          style="padding: 15px; width: 100%; font-size: 18px; background: #fff; border: none;"
                          @change="saveNotes"></textarea>
            </div>
        </div>
    </div>
</template>